import React from 'react';
import PropTypes from 'prop-types';

const RestrictedPage = ({ classes }) => {
  return <div className={classes.message}>Page Restricted</div>;
};

RestrictedPage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

RestrictedPage.defaultProps = {
  classes: {},
};

export default RestrictedPage;
